import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {increment, decrement} from '../store/Reducer/CounterReducer'
const Counter = () => {

  const { count } = useSelector();
  const dispatch = useDispatch();
  return (
    <div>
      <h1>Count: {count}</h1>
      <button onClick={() => dispatch(increment(count))}>+</button>
      <button onClick={() => dispatch(decrement(count))}>-</button>
      {/* <button onClick={() => dispatch()}>Reset</button> */}
    </div>
  );
};

export default Counter;
